// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { linkActionStyles, linkIconStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/* Store Custom Code - Start */
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { linkButtonStyles } from "@store/Themes/common/mixins/link";
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
/* Store Custom Code - End */

export const linkGetIconProps = (
    src: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
    // Store Custom Code
    spacing?: string,
): LinkPresentationProps["icon"] => ({
    position,
    iconProps: {
        src,
        color: "inherit",
        css: linkIconStyles(typeof size === "number" ? pxToRem(size) : size, spacing), // Store Custom Code
    },
});

export const linkGetActionLinkProps = (
    src?: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
    // Store Custom Code
    marginTop?: string,
): LinkPresentationProps => ({
    /* Store Custom Code - Start */
    icon: mergeProps<LinkPresentationProps["icon"]>(linkGetIconProps(src, position, size), {
        iconProps: {
            css: css`
                margin-top: ${marginTop ?? pxToRem(1)};
            `,
        },
    }),
    /* Store Custom Code - End */
    css: css`
        ${linkActionStyles()}
        align-items: flex-start;
    `,
});

/* Store Custom Code - Start */
export const linkGetButtonLinkProps = (
    src?: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps => ({
    icon: mergeProps<LinkPresentationProps["icon"]>(linkGetIconProps(src, position, size), {
        iconProps: {
            css: css`
                margin-right: ${() => pxToRem(buttonSizeVariants["medium"].iconPadding)};
                margin-left: ${() => pxToRem(buttonSizeVariants["medium"].iconPadding)};

                svg {
                    width: ${() => pxToRem(buttonSizeVariants["medium"].icon)};
                    height: ${() => pxToRem(buttonSizeVariants["medium"].icon)};
                }
            `,
        },
    }),
    css: linkButtonStyles(),
});
/* Store Custom Code - End */
